module.exports = __webpack_public_path__ + "img/lishirenwu-1@3x.d1c9360a.png";